export const AppConfig = {
    dialog_width: '1000px',
    dialog_width_xs: '400px',
    dialog_max_height: '90vh'
};
